import { render, staticRenderFns } from "./FormTier.vue?vue&type=template&id=475a1908"
import script from "./FormTier.vue?vue&type=script&lang=js"
export * from "./FormTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports